<app-informative-detail *ngIf="!isLoading" [isMarkAsHandleApplicable]="true"></app-informative-detail>

<app-comment-list *ngIf="!isLoading" [taskId]="taskId" [networkMemberId]="networkMemberId" [networkMemberName]="networkMemberName" [clientName]="clientName" [service]="informativeTaskService" [status]="status"
    [isTagSystemApplicable]="false"></app-comment-list>

<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>